<template>
	<div>
		<el-dialog :visible.sync="showmodal" @close="$emit('close-modal')" title="Process Return" width="30%" height="70%">
			<div class="flex my-4 flex-col gap-2 justify-center">
				<div class="flex flex-col gap-2 w-100">
					<div class="font-semibold">Cost:</div>
						<div><input class="input" disabled  /></div>
				</div>
				<hr class="my-2" />

				<div class="flex gap-12 items-center justify-end w-100 mt-7 pb-48">
					<p class="cursor-pointer mr-7" @click="$emit('close-modal')">Cancel</p>
					<base-button text="Pay" @click="showConfirmHandoffModal = true" />
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		props : {
			showmodal : Boolean
		}
	}
</script>